// globalRouter.ts
import { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction | null = null;

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const goTo = (path: string) => {
  if (!navigate) {
    console.error("Navigate function not initialized yet!");
    return;
  }
  navigate(path);
};
